import { experiment } from "@faire/web/common/settings/declarations/experiment";

export const FE_BATCH_11_CATEGORY_FAQS_250708 = experiment({
  name: "FE_BATCH_11_CATEGORY_FAQS_250708",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-10-09",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
